import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { useItemAlign } from './context'

interface ItemActionsProps extends ComponentProps<'span'> {
  className?: string
}

/** The trailing controls: a Button, a state chip and its Menu, a Select. Sized to themselves, never squeezed. */
function ItemActions({ className, children, ...props }: ItemActionsProps) {
  const align = useItemAlign()
  return (
    <span
      data-slot="item-actions"
      className={twMerge('flex flex-none items-center gap-2', align === 'start' && 'self-start', className)}
      {...props}
    >
      {children}
    </span>
  )
}

export { ItemActions }
export type { ItemActionsProps }
